export const EMOTION_CSS_SSR_KEY = "swo-css";
